/**
 * @desc: - 块加载未完成时显示loading的ICON 【位置依赖父级需要使用relative 属性】
 * @author: ammo
 * example: <Loader />
 */
import React from 'react';
import IMG from './i/empty.svg'
import './loader.scss'

export default class Loader extends React.Component {

  render() {
    return (
        <div className='loader-icon'></div>
    );
  }
}

export class SMLoader extends React.Component {
  render() {
    return <div className="new-loader-icon" />
  }
}

export class TableLoader extends React.Component {
  render(){
    return <tr>
            <td colSpan={this.props.merge} style={style}>
              请选择查询条件之后进行查询
            </td>
           </tr>
  }
}

export class TableEmpty extends React.Component {
  render(){
    return <tr>
            <td colSpan={this.props.merge} style={style}>
              <img src={IMG} />
              <br/>
              暂无数据
            </td>
           </tr> 
  }
}

export class TableResMsg extends React.Component {
  render(){
    return <tr>
            <td colSpan={this.props.merge} style={style}>              
              <br/>
              {this.props.msg}
            </td>
           </tr> 
  }
}

export class DivEmpty extends React.Component {
  render(){
    return <div className='div-empty' style={{height: this.props.height || 'auto'}}>
              <img src={IMG} />
              <br/>
              <div>暂无数据</div>
           </div> 
  }
}

const style = {
  borderRight: '1px solid #edecf6',
  borderBottom: '1px solid #edecf6',
  textAlign: 'center',
  lineHeight: '24px',
  color: '#8994ab',
  padding: '30px 5px',
  fontSize: '12px'
}